import fetcher from '../utils/api';

const managerService = {
  getAnalytics: async () => fetcher('manager/analytics/', 'GET', true)
};

export default managerService;
